module.exports = __webpack_public_path__ + "static/media/profileicon.5e1379a5.jpg";